import React from "react";
import SectionHeader, { SectionWrapper, Reveal } from "./SectionHeader";

const BRANDS = [
  "NIKE", "REEBOK", "MICROSOFT", "GOOGLE",
  "ICICI BANK", "PVR", "ASUS", "HP",
  "BITS PILANI", "IIT KANPUR", "IIT MUMBAI", "GOVT. OF DELHI",
  "BIGO", "ALIBABA", "BALAJI MOTION PICTURES",
  "NICOTEX", "PRINGLES", "LIKEE", "MOTOROLA",
  "HONDA", "ADIDAS", "WARNER BROS.", "EROS INT'L",
  "FASTRACK", "GO PAISA", "GODREJ", "SYMBIOSIS [PUNE]",
  "CAFE COFFEE DAY", "AND WOMEN", "AIESEC INDIA",
  "BIG BAZAAR [FUTURE GROUP]", "FREECULTR",
  "MAKER STUDIOS [DISNEY]", "IIT [GUWAHATI]",
  "LINC PENS & PLASTICS LTD.",
  "AI IMPACT SUMMIT 2026", "CONVERGENCE INDIA EXPO",
  "LG",
];

const BrandCollaborations = () => {
  return (
    <SectionWrapper id="brands">
      <SectionHeader
        code="// CH.08 — ALLIANCES"
        title="Alliance.Layer"
        kicker="A curated selection of strategic alliances with recognized leaders across industries."
        tid="brands"
      />

      <Reveal>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {BRANDS.map((b, i) => (
            <div
              key={b}
              className="brand-tile hud-corners"
              style={{ animationDelay: `${i * 60}ms` }}
              data-testid={`brand-${b.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <span className="hud-tr" />
              <span className="hud-bl" />
              {b}
            </div>
          ))}
        </div>
      </Reveal>

      {/* Scrolling marquee of values */}
      <div className="mt-14 overflow-hidden border-y border-cyan-500/15 py-4">
        <div className="marquee-track font-display font-black text-xl md:text-3xl uppercase tracking-tight text-white/20">
          {[0, 1].map((rep) => (
            <div key={`rep-${rep}`} className="flex gap-12 pr-12">
              {["Strategic · Alliances", "Youth · First", "Bharat · Native",
                "Verified · Impact", "Investor · Grade", "Creative · Command"].map((t) => (
                <span key={`${rep}-${t}`} className="flex items-center gap-6">
                  <span className="w-2 h-2 bg-cyan-400 rounded-full pulse-dot" />
                  {t}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
};

export default BrandCollaborations;
